import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from '@angular/core';
import { footerSetting } from 'src/_lib/interfaces/homepagesettings.interface';
import { SubFooterComponent } from './sub-footer/sub-footer.component';
import { TopFooterComponent } from './top-footer/top-footer.component';
import { FooterService } from 'src/_lib/service/footer.service';
import { footers } from 'src/_lib/interfaces/footer.interface';
import { NgClass, NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { DynamicThemeClassService } from 'src/_lib/service/dynamic-theme-class.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [TopFooterComponent, SubFooterComponent, NgIf,NgClass]
})
export class FooterComponent implements OnInit, OnChanges, OnDestroy {
  showSocialIconsCopyright: boolean = null;
  showContactDetails: boolean = null;
  footerData: footers | null = null;
  isTopFooterLoaded: boolean = false;
  private footerSub: Subscription;
  chTheme7 = environment.chTheme7;
  chTheme12 = environment.chTheme12;
  commonImagePath: string = environment.commonImagePath;

  @Input() footerSettings: footerSetting<string> = null;

  constructor(
    private footerService: FooterService, private dynamicThemeClassService: DynamicThemeClassService
  ) { }
    themeClass(divName: string): string {
      return this.dynamicThemeClassService.generateClassName(divName);
    }

  ngOnInit(): void {
    this.footerSub = this.footerService.footerDataUpdate.subscribe(
      (data: footers) => {
        this.footerData = data;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['footerSettings']?.currentValue) {
      this.footerSettings = changes['footerSettings'].currentValue;
      this.showContactDetails =
        this.footerSettings.contactDetails === 'true';
      this.showSocialIconsCopyright =
        this.footerSettings.socialIconsCopyright === 'true';
    }
  }

  onTopFooterLoaded(): void {
    this.isTopFooterLoaded = true;
  }

  ngOnDestroy(): void {
    this.footerSub?.unsubscribe();
  }
}